<template>
  <div class="tiles-container">
    <transition-group name="fade" tag="div">
      <div v-for="(group, gIndex) in chunkedFeed" :key="'group-' + gIndex" class="tile-group">
        
        <!-- Row 1: Hero Tile (Full width, 2 comments) -->
        <div v-if="group[0]" class="news-row row-hero">
          <Entry
            :entry="group[0]"
            tileType="hero"
            :maxComments="2"
            class="tile-item"
          />
        </div>

        <!-- Row 2: Standard Grid (2 side-by-side) -->
        <div v-if="group[1] || group[2]" class="news-row row-halves">
          <Entry
            v-if="group[1]"
            :entry="group[1]"
            tileType="standard"
            :maxComments="1"
            class="tile-item"
          />
          <Entry
            v-if="group[2]"
            :entry="group[2]"
            tileType="standard"
            :maxComments="1"
            class="tile-item"
          />
        </div>

        <!-- Row 3: Full Width Standard -->
        <div v-if="group[3]" class="news-row row-full">
          <Entry
            :entry="group[3]"
            tileType="wide"
            :maxComments="3"
            class="tile-item"
          />
        </div>

        <!-- Row 4: Standard Grid -->
        <div v-if="group[4] || group[5]" class="news-row row-halves">
          <Entry
            v-if="group[4]"
            :entry="group[4]"
            tileType="standard"
            :maxComments="2"
            class="tile-item"
          />
          <Entry
            v-if="group[5]"
            :entry="group[5]"
            tileType="standard"
            :maxComments="2"
            class="tile-item"
          />
        </div>

        <!-- Row 5: Complex Mix (Left Stack, Right Tall) -->
        <div v-if="group[6] || group[7] || group[8]" class="news-row row-mix">
          <div class="stack-column">
            <Entry
              v-if="group[6]"
              :entry="group[6]"
              tileType="compact"
              :maxComments="1"
              class="tile-item stacked"
            />
            <Entry
              v-if="group[7]"
              :entry="group[7]"
              tileType="compact"
              :maxComments="1"
              class="tile-item stacked"
            />
          </div>
          <div class="tall-column">
             <Entry
              v-if="group[8]"
              :entry="group[8]"
              tileType="tall"
              :maxComments="5"
              class="tile-item tall"
            />
          </div>
        </div>

        <!-- Row 6: Complex Mix Mirrored (Left Tall, Right Stack) -->
        <div v-if="group[9] || group[10] || group[11]" class="news-row row-mix">
          <div class="tall-column">
            <Entry
              v-if="group[9]"
              :entry="group[9]"
              tileType="tall"
              :maxComments="5"
              class="tile-item tall"
            />
          </div>
          <div class="stack-column">
            <Entry
              v-if="group[10]"
              :entry="group[10]"
              tileType="compact"
              :maxComments="1"
              class="tile-item stacked"
            />
            <Entry
              v-if="group[11]"
              :entry="group[11]"
              tileType="compact"
              :maxComments="1"
              class="tile-item stacked"
            />
          </div>
        </div>

        <!-- Row 7: Compact Row (No comments) -->
        <div v-if="group[12] || group[13]" class="news-row row-halves">
          <Entry
            v-if="group[12]"
            :entry="group[12]"
            tileType="standard"
            :maxComments="1"
            class="tile-item"
          />
          <Entry
            v-if="group[13]"
            :entry="group[13]"
            tileType="standard"
            :maxComments="1"
            class="tile-item"
          />
        </div>

        <!-- Row 8: Final Full Width -->
        <div v-if="group[14]" class="news-row row-full">
          <Entry
            :entry="group[14]"
            tileType="wide"
            :maxComments="2"
            class="tile-item"
          />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import Entry from "./Entry.vue";

export default {
  name: "Tiles",
  components: { Entry },
  props: {
    feed: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    // Preserving your chunking logic
    chunkedFeed() {
      const result = [];
      if (!this.feed) return result;
      for (let i = 0; i < this.feed.length; i += 14) {
        result.push(this.feed.slice(i, i + 14));
      }
      return result;
    }
  }
};
</script>

<style scoped>
.tiles-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.tile-group {
  display: flex;
  flex-direction: column;
  gap: 24px; /* Consistent spacing */
  margin-bottom: 3rem;
}

.news-row {
  display: grid;
  gap: 24px;
  width: 100%;
}

/* --- Row Layouts --- */
.row-hero, .row-full {
  grid-template-columns: 1fr;
}

.row-halves {
  grid-template-columns: repeat(2, 1fr);
}

.row-mix {
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
}

/* --- Column Types --- */
.stack-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.tall-column {
  display: flex;
}

.tile-item {
  width: 100%;
  height: 100%; /* Ensures tiles stretch to fill container */
}

.stacked {
  flex: 1; /* Makes stacked items split height evenly */
}

/* --- Responsive --- */
@media (max-width: 768px) {
  .news-row {
    grid-template-columns: 1fr !important; /* Stack everything on mobile */
    gap: 1.5rem;
  }
  
  .stack-column, .tall-column {
    width: 100%;
  }

  /* Reset flex heights for mobile stacking */
  .stacked, .tall {
    height: auto;
    flex: none;
  }
  
  .tile-group {
    gap: 1.5rem;
  }
}

/* Transitions */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/site/Tiles.vue